interface ErrorResponse {
    code: number;
    message: string;
}

export interface JackpotPickBetsState {
    jackpotPickBetsData: any;
    loading: boolean;
    jackpotPickBetsError: ErrorResponse | null;
}


export enum JackpotPickBetsActionTypes {
    FETCH_JACKPOT_PICK_BETS_DATA = "FETCH_JACKPOT_PICK_BETS_DATA",
    FETCH_JACKPOT_PICK_BETS_DATA_SUCCESS = "FETCH_JACKPOT_PICK_BETS_DATA_SUCCESS",
    FETCH_JACKPOT_PICK_BETS_DATA_ERROR = "FETCH_JACKPOT_PICK_BETS_DATA_ERROR",
}

export type JackpotPickBetsAction =
    | { type: JackpotPickBetsActionTypes.FETCH_JACKPOT_PICK_BETS_DATA }
    | { type: JackpotPickBetsActionTypes.FETCH_JACKPOT_PICK_BETS_DATA_SUCCESS; payload: any[] }
    | { type: JackpotPickBetsActionTypes.FETCH_JACKPOT_PICK_BETS_DATA_ERROR; payload: any };